import { DateTimeInput, Modal } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { usePredefinedToasts } from 'utils/Toast';
import { ModalProps } from 'store/modal';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { Stack } from '@mui/material';
import { useUpdateSurvey } from 'store/surveys';
import moment from 'moment';

interface Values {
  endsAt: string;
}

interface Props extends ModalProps {
  surveyId: string;
  initialValues: {
    endsAt: string;
  };
}

export const EditEndDateModal: FC<Props> = ({
  surveyId,
  initialValues,
  closeModal,
}) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: {
      endsAt: initialValues.endsAt,
    },
  });

  const { mutate: updateSurvey, isLoading } = useUpdateSurvey();

  const onSubmit: SubmitHandler<Values> = async (values) => {
    updateSurvey(
      { surveyId, data: { endDateTime: values.endsAt } },
      {
        onSuccess: () => {
          closeModal();
          predefinedToasts.success.updated();
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('alternatives.actions.change_deadline')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Stack gap={2}>
          <Controller
            name="endsAt"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => (
              <DateTimeInput
                label={t('common.date')}
                name={name}
                value={value}
                onChange={onChange}
                datePickerProps={{
                  minDateTime: moment(),
                }}
                required
                ref={ref}
              />
            )}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
